module.exports = __webpack_public_path__ + "static/media/EDUCATIONAL EXCURSIONS.9c785d45.png";